import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(private _route: ActivatedRoute) {}
  appName: string = 'this application';
  ngOnInit(): void {
    this._route.data.subscribe(data =>
      this.appName = data['appName'] ?? this.appName
    );
  }
}
